import QueryString from 'qs';

export const paramsArrayRepeat = (params: Record<string, unknown>) => QueryString.stringify(params, { arrayFormat: 'repeat' });
